import { Fragment } from 'react/jsx-runtime';
import { StyledCardContent, StyledCardHead, StyledCardHeadRight } from '../StyledComponents';
import { RowItemHead } from './details/RowItemHead';
import { RowItemBody } from './details/RowItemBody';
import { RowItemButtons } from './RowItemButtons';
import { ILockerGateItem } from 'api/interfaces/lockerGate';
import { getGateItemIcons } from './icons/getGateItemIcons';
import { TimeItem } from './details/TimeItem';

interface GateItemProps {
	lockerGateItem: ILockerGateItem;
}

export const GateItem = ({ lockerGateItem }: GateItemProps) => {
	const visibleIcons = getGateItemIcons(lockerGateItem);

	return (
		<>
			<StyledCardContent>
				<StyledCardHead>
					<RowItemHead {...lockerGateItem} />
					<StyledCardHeadRight>
						<TimeItem
							lastOpenedAtUTC={lockerGateItem.lastOpenedAtUTC}
							openType={lockerGateItem.openStatus}
							openDurationInMinutes={lockerGateItem.openDurationInMinutes}
							subText={lockerGateItem.lastUserName}
						/>
						{visibleIcons.map((icon, index) => (
							<Fragment key={index}>{icon}</Fragment>
						))}
					</StyledCardHeadRight>
				</StyledCardHead>
				<RowItemBody item={lockerGateItem} />
			</StyledCardContent>
			<RowItemButtons {...lockerGateItem} />
		</>
	);
};
